export default {
    addCart (state, payload) {
      state.cart_num = payload.cart_num
      state.user_name = payload.username,
      state.coupon_num = payload.coupon_num
    }
  }
  